import type { SeriesUnit } from '../types';

/**
 * A maître d'AI chart or table value in its declared unit (backend
 * field_units.py). `pct` is percent points (11.4 = 11.4%), `fraction` a share
 * of one (0.114 = 11.4%). The unit comes from the tool field, never from the
 * size of the number, so 0.3 in percent points stays 0.3%.
 */
export function percentPoints(value: number, unit: SeriesUnit | undefined): number {
  return unit === 'fraction' ? value * 100 : value;
}

export function isPercentUnit(unit: SeriesUnit | undefined): boolean {
  return unit === 'pct' || unit === 'fraction';
}

export function formatAgentValue(value: number, unit?: SeriesUnit, digits = 0): string {
  if (!Number.isFinite(value)) return String(value);
  switch (unit) {
    case 'eur':
      return `€${value.toLocaleString('de-CH', { maximumFractionDigits: digits })}`;
    case 'pct':
    case 'fraction': {
      const points = Math.round(percentPoints(value, unit) * 10) / 10;
      return `${points.toLocaleString('de-CH', { maximumFractionDigits: 1 })}%`;
    }
    case 'minutes':
      return `${value.toLocaleString('de-CH', { maximumFractionDigits: 0 })} min`;
    default:
      return value.toLocaleString('de-CH', { maximumFractionDigits: digits });
  }
}
